export const environment = {
  production: true,
  apiUrl: 'https://api.distribuidorasc.com.br/',
  frontUrl: 'https://distribuidorasc.com.br/',
  linkImages: 'https://d20p8exwoll05u.cloudfront.net/distri/products/',
  linkBrands: 'https://d20p8exwoll05u.cloudfront.net/distri/brands/',
};
